// extracted by mini-css-extract-plugin
module.exports = {"channelInfo":"ChannelInfo_channelInfo__E3JgV","alignStartItem":"ChannelInfo_alignStartItem__1ynUv","prePayInput":"ChannelInfo_prePayInput__2sDmr"};